export default "__VITE_PUBLIC_ASSET__dfb3abd5__"